<div #container fxLayout="column" fxLayoutAlign="start start" class="container"
     [class.new]="highlightNew && notification.status === 'not viewed'"
     [class.inquiry]="notification.type.startsWith('inquiry')">
    @if (isNew) {
        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
            <div fxLayout="row" fxLayoutAlign="start center">
                <af-status [statusText]="'i18n_af_notificationNew' | translate"
                           [status]="StatusStyle.SUCCESS_DARK"
                           textSize="t4"
                           icon="ic_notification_new"/>
                @if (notification.type.startsWith('inquiry')) {
                    <af-status
                        class="ml-16"
                        [statusText]="'i18n_af_notificationLabelInquiry'| translate"
                        [status]="StatusStyle.WARNING_DARK"
                        textSize="t4"
                        icon="ic_notification_inquiry"/>
                }
            </div>
            <div class="t2-semi-bold">{{ notification.date | date : 'dd.MM.yyyy HH:mm' }}</div>
        </div>
    }
    <div fxLayout="column" fxLayoutAlign="start start" class="mt-8 w-100">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
            <ng-container [ngTemplateOutlet]="summaryTemplate"
                          [ngTemplateOutletContext]="{key: 'i18n_af_notification_summary_template_key_topic', value:parsedSummary.topic}">
            </ng-container>
            @if (!isNew) {
                <div class="t2-semi-bold mt-8">{{ notification.date | date : 'dd.MM.yyyy HH:mm' }}</div>
            }
        </div>
        <ng-container [ngTemplateOutlet]="summaryTemplate"
                      [ngTemplateOutletContext]="{key: 'i18n_af_notification_summary_template_key_date', value:parsedSummary.date}">
        </ng-container>
        <ng-container [ngTemplateOutlet]="summaryTemplate"
                      [ngTemplateOutletContext]="{key: idTranslationKey, value:parsedSummary.id}">
        </ng-container>
        @if (parsedSummary.parentId) {
            <ng-container [ngTemplateOutlet]="summaryTemplate"
                          [ngTemplateOutletContext]="{key: 'i18n_af_notification_summary_template_key_id_incident', value:parsedSummary.parentId}">
            </ng-container>
        }
        @if (statusTranslationKey) {
            <ng-container [ngTemplateOutlet]="summaryTemplate"
                          [ngTemplateOutletContext]="{key: statusTranslationKey, value:parsedSummary.status}">
            </ng-container>
        }
        @if (parsedSummary.category) {
            <ng-container [ngTemplateOutlet]="summaryTemplate"
                          [ngTemplateOutletContext]="{key: 'i18n_af_notification_summary_template_key_category', value:parsedSummary.category}">
            </ng-container>
        }
        @if (parsedSummary.message) {
            <ng-container [ngTemplateOutlet]="summaryTemplate"
                          [ngTemplateOutletContext]="{key: 'i18n_af_notification_summary_template_key_message', value:parsedSummary.message}">
            </ng-container>
        }
    </div>
</div>
<ng-template #summaryTemplate let-key='key' let-value="value">
    <div class="t2 mt-8"
         [innerHTML]="'i18n_af_notification_summary_template' | translate : {
            key: key | translate,
            value: value,
            class: 't2-semi-bold'
            }">
    </div>
</ng-template>
